import * as React from "react";

import {Flag, Label, Segment, Table, Image, Pagination, Checkbox} from "semantic-ui-react";

import {IStateProperty} from "../../../components/StateViewBar";
import {OptionTextDto} from "../../../services/Client";
import {getWFStatusImageSrc, handleStepName} from "../../../components/Table/components/workflow/WorkFlowState";

import DataAdapterOptionsView from "../DataAdapterOptionsView";
import Button from "../../../components/Button";
import PromtFormatter from "src/components/Table/components/reactQuill/PromtFormatter";

export interface IMODOverviewTableProps {
    items: DataAdapterOptionsView[];
    tablePage: number;
    t: reactI18Next.TranslationFunction;
    onChangePage: (pageNumber: number) => void;
    nextAction?: () => void;
    isResultTab: boolean;
    onRemove: (id:number,isSelected:boolean) => void;
    selectedItemsOnPreviewScreen:number[];
}

const getTableHeaderCells = (t: reactI18Next.TranslationFunction) => {
    return (
        <>
            <Table.HeaderCell>{}</Table.HeaderCell>
            <Table.HeaderCell>{t("PSL_MULTI_DLT:OPTION_IDENTIFIER")}</Table.HeaderCell>
            <Table.HeaderCell>{t("PSL_MULTI_DLT:SHORTTEXT")}</Table.HeaderCell>
            <Table.HeaderCell>{t("PSL_MULTI_DLT:CURRENT_STATUS")}</Table.HeaderCell>
        </>
    );
};

const getIdentifierCellData = (optionCode: string, optionType?: string) => {
    return (
        <Label size={'large'} className={'whitespace--nowrap'}>
            {optionCode}
            <Label.Detail>
                {optionType}
            </Label.Detail>
        </Label>
    );
};

const getTextsCellData = (texts: OptionTextDto[]) => {
    return (
        <Segment.Group horizontal={true}>
            {texts.sort((a, b) =>
                (a.language && b.language && a.language.code && b.language.code && a.language.code > b.language.code) ? 1 : -1)
                .map((txt: OptionTextDto, idx: number) =>
                    <Segment
                        key={"txt-" + idx}
                        className={'texts-segment'}
                    >
                        <Flag
                            name={txt.language && txt.language.code === "de" ? "de" : "gb"}
                            className={'texts-flag'}

                        />
                        {txt.shorttext || ""}
                    </Segment>
                )}
        </Segment.Group>
    );
};

const getCurrentStatusCellData = (statusValueState?: number, statusValueStates?: IStateProperty[]): JSX.Element => {
    const currentStep = statusValueState && statusValueStates ?
        statusValueStates.find((element) => element.id === statusValueState) : undefined;

    return (
        <>
            {currentStep &&
            <div>
                <div className='workflow-status'>{handleStepName(currentStep.hoverText, currentStep.rejectReason, false)}</div>
                <Image
                    className='margin-top--10px'
                    centered={true}
                    src={getWFStatusImageSrc(currentStep.type)}
                    width={30}
                    height={30}
                />
            </div>
            }
        </>
    );
};

export const MODOverviewTable: React.StatelessComponent<IMODOverviewTableProps> = (props: IMODOverviewTableProps) => {
    const items = props.items.slice((props.tablePage - 1) * 10, props.tablePage * 10);

    return (
        <React.Fragment>
            <div className='psl-mod-table-container'>
                <Table
                    id={'psl-mod-overview-table'}
                    celled={true}
                    structured={true}
                    textAlign={'center'}
                    className={props.isResultTab ? 'psl-mod-red-header' : ''}
                >
                    <Table.Header>
                        <Table.Row>

                            {getTableHeaderCells(props.t)}
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {items.map((item: DataAdapterOptionsView, index: number) => {
                            return (
                              <Table.Row key={"row-" + index}>
                                <Table.Cell>
                                  <Checkbox
                                    checked={props.selectedItemsOnPreviewScreen.indexOf(item.objectId)!==-1}
                                    slider={true}
                                    onChange={(e, v) => {
                                     props.onRemove(item.objectId,v.checked as boolean);
                                    }}
                                  />
                                </Table.Cell>
                                <Table.Cell>
                                  {getIdentifierCellData(
                                    item.optionBasicView,
                                    item.optionTypeView
                                  )}
                                </Table.Cell>
                                <Table.Cell>
                                  {getTextsCellData(item.texts)}
                                </Table.Cell>
                                <Table.Cell>
                                  {getCurrentStatusCellData(
                                    item.statusValueState,
                                    item.statusValueStates
                                  )}
                                </Table.Cell>
                              </Table.Row>
                            );
                        })}
                    </Table.Body>

                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell colSpan={3}>
                                <Pagination
                                    activePage={props.tablePage}
                                    totalPages={Math.ceil(props.items.length / 10)}
                                    onPageChange={(e, c) => props.onChangePage(c.activePage as number)}
                                />
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                </Table>
            </div>
            {props.nextAction &&
                <div className='psl-mod-navigation-buttons'>
                    <Button
                        icon={'arrow right'}
                        onClick={props.nextAction}
                        disabled={props.selectedItemsOnPreviewScreen.length === 0}
                    />
                </div>
            }
        </React.Fragment>
    );
};



// WEBPACK FOOTER //
// ./src/views/OptionsView/multipleOptionDeletionDialog/MODOverviewTable.tsx